import React from "react"
import { Link } from "../Router"
import { isCurrentPathActive } from "../../util/navigation"
import { Desktop, Mobile } from "../util/breakpoints"
import { forceTrailingSlash } from "../../util/urlTransforms"
import * as contentTypes from "../../api/contentTypes"

export default ({ slug, navigationTitle, onLinkClick, title, metaData, metaDataExtra, classes, contentType, url }) => {

  slug = forceTrailingSlash( slug )

  // is it an external link?
  const isExternalLink = contentType && contentType == contentTypes.NAVIGATION_ITEM_EXTERNAL_LINK

  const linkBody = (
    <>
      <Desktop>
        <span className="m-navigation-group__title">{ navigationTitle || title }</span>
        { metaDataExtra && <span className="m-navigation-group__meta-extra">{ metaDataExtra }</span> }
        { metaData && <span className="m-navigation-group__meta">{ metaData }</span> }
      </Desktop>

      <Mobile>
        <div className="m-navigation-group__wrapper">
          <span className="m-navigation-group__title">{ navigationTitle || title }</span>
          { metaData && <span className="m-navigation-group__meta">{ metaData }</span> }
        </div>
        { metaDataExtra && <span className="m-navigation-group__meta-extra">{ metaDataExtra }</span> }
      </Mobile>
    </>
  )

  return (
    <>
      { isExternalLink &&  
        <a
          target="_blank"
          rel="noopener noreferrer nofollow"
          onClick={ onLinkClick }
          className={ "m-navigation-group__link" + (classes ? " " + classes : "") }
          href={ url }
        >
          { linkBody }
        </a>
      }

      { !isExternalLink &&
        <Link className={ "m-navigation-group__link" +
                        (isCurrentPathActive(slug) ? " m-navigation-group__link--active" : "") +
                        (classes ? " " + classes : "") }
                        onClick={ onLinkClick }
                        to={ `/${slug}` } >
          { linkBody }
        </Link>
      }    
    </>
  )

}